import {Component, OnInit} from '@angular/core';
import {MatCard, MatCardActions, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {ApiService, Helper} from "../api.service";
import {Router} from "@angular/router";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-dashboard',
  imports: [
    MatCard,
    MatCardHeader,
    MatButton,
    MatIcon,
    MatCardTitle,
    MatCardContent,
    MatCardActions,
    MatProgressSpinner,
    DatePipe
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  public activities: any[] = [];
  public loading: boolean = false;

  constructor(private api: ApiService, private router: Router) {
  }

  async ngOnInit() {
    this.loading = true;
    this.activities = await this.api.getAvailableActivities();
    this.activities.sort(function (a, b) {
      return a.params.order - b.params.order;
    });
    this.loading = false;
  }

  goToActivity(id: any) {
    this.router.navigate(['activity', id]);
  }

  protected readonly Helper = Helper;
}
